import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { createWhatsAppUrl, WHATSAPP_NUMBER } from '../utils/whatsapp';

const { FiPhone, FiMessageCircle, FiArrowUpRight } = FiIcons;

function Appointment() {
  const [notice, setNotice] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const message = [
      'Hello Saffron & Sage! I would like to enquire about an appointment.',
      `Name: ${form.get('name')}`,
      `Phone: ${form.get('phone')}`,
      `Service: ${form.get('service')}`,
      `Preferred date: ${form.get('date')}`
    ].join('\n');

    setNotice('Your WhatsApp message is ready. Review and send it to confirm your enquiry.');
    window.open(createWhatsAppUrl(message), '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="appointment-section" id="appointment">
      <div className="container appointment-grid">
        <Reveal className="appointment-copy">
          <SectionHeading
            eyebrow="Your chair is waiting"
            title="Let's find a time that works."
            description="Tell us a little about what you have in mind. We'll take you to WhatsApp to review and send your appointment enquiry."
            light
          />
          <div className="contact-options">
            <a href={`tel:+${WHATSAPP_NUMBER}`}>
              <span><SafeIcon icon={FiPhone} /></span>
              <div>
                <small>CALL THE SALON</small>
                <strong>+91 98765 43210</strong>
              </div>
            </a>
            <a href={createWhatsAppUrl('Hi! I would like to chat with the salon.')}>
              <span><SafeIcon icon={FiMessageCircle} /></span>
              <div>
                <small>CHAT ON WHATSAPP</small>
                <strong>Usually replies within a few hours</strong>
              </div>
            </a>
          </div>
        </Reveal>

        <Reveal className="appointment-form-wrap" delay={0.1}>
          <form className="appointment-form" onSubmit={handleSubmit}>
            <h3>Request an appointment</h3>
            <p>We'll help you take it from here.</p>
            <div className="form-row">
              <label>
                Your name
                <input required name="name" type="text" placeholder="e.g. Priya Sharma" />
              </label>
              <label>
                Phone number
                <input required name="phone" type="tel" pattern="[+]?[0-9\s-]{10,15}" placeholder="+91 98765 43210" />
              </label>
            </div>
            <div className="form-row">
              <label>
                Service
                <select required name="service" defaultValue="">
                  <option value="" disabled>Select a service</option>
                  <option>Hair styling</option>
                  <option>Hair colour</option>
                  <option>Facial &amp; skin care</option>
                  <option>Makeup or bridal</option>
                  <option>Men's grooming</option>
                  <option>Other</option>
                </select>
              </label>
              <label>
                Preferred date
                <input required name="date" type="date" min={new Date().toISOString().split('T')[0]} />
              </label>
            </div>
            <button className="button button-gold form-submit" type="submit">
              Continue on WhatsApp <SafeIcon icon={FiArrowUpRight} />
            </button>
            <span className="form-note">
              Your details are used to prepare your WhatsApp enquiry; this demo does not store submissions.
            </span>
            {notice && <p className="form-notice" role="status">{notice}</p>}
          </form>
        </Reveal>
      </div>
    </section>
  );
}

export default Appointment;
